import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
import { SiteFooter } from '../components/ui/SiteFooter';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-628" data-mp="1ak9aq1acb7l5">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-629" data-mp="11le6uvurq9l0">
        <a href="/" data-id="element-630" data-mp="wnm7xhvphn7b">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-631" data-mp="rm6jdfubkyk6" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-632" data-mp="2exmdsh2t1sx7">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-633" data-mp="208zts228gczn">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-634" data-mp="257t98012ye2g">
            Download the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-635" data-mp="2svknh966l16d">
            Practitioners
          </a>
        </div>
      </nav>

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-636" data-mp="2nyaph54q7h6x">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-637" data-mp="17k1bn4y41auc"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-638" data-mp="1ch17yo55qz89"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-639" data-mp="35eyewwv8u2nr">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-640" data-mp="30hy8ulye8zwn">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-641" data-mp="2vfz3x7n09uxl">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-642" data-mp="2migd1mmokmds">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-643" data-mp="kq0jkwav4o4z">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-644" data-mp="kno3ypskupv3">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-645" data-mp="x2m7g6uc3d92" />
      <BusinessModel data-id="element-646" data-mp="11zw4o8nyst7g" />
      <TractionSection data-id="element-647" data-mp="11ybbamddzgb6" />
      <GrowthRoadmap data-id="element-648" data-mp="11yl22c699rhx" />
      <VisionSection data-id="element-649" data-mp="12177a55obuwz" />
      <LeadershipSection data-id="element-650" data-mp="4buhhr3v3ku6" />
      <FundraiseSection data-id="element-651" data-mp="4cnp0uanaedd" />

      <SiteFooter currentPath="/investors" data-id="element-652" data-mp="4df7r4j58hm8" />
    </main>;
}